var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 600,
    viewBox: "0 0 1200 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ultra-glow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "over"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pro-sweep",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#06b6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#06b6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#06b6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#06b6d4"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x1",
    from: "-100%",
    to: "100%",
    dur: "2.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "x2",
    from: "0%",
    to: "200%",
    dur: "2.5s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("text", {
    x: 506,
    y: 206,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 220,
    fontWeight: 900,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#014a57",
    style: {
      letterSpacing: 10
    }
  }, "\n    SAMITH\n  "), /*#__PURE__*/React.createElement("text", {
    x: 503,
    y: 203,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 220,
    fontWeight: 900,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#027387",
    style: {
      letterSpacing: 10
    }
  }, "\n    SAMITH\n  "), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ultra-glow)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 200,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 220,
    fontWeight: 900,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "url(#pro-sweep)",
    stroke: "#06b6d4",
    strokeWidth: 3,
    style: {
      letterSpacing: 10
    }
  }, "\n      SAMITH\n    ")), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 200,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 220,
    fontWeight: 900,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    style: {
      letterSpacing: 10,
      pointerEvents: "none"
    }
  }, "\n    SAMITH\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9b00a6050989dcc6dee1f26930b1fa29.svg";
export { ForwardRef as ReactComponent };